import { ApiResourceBaseClass as t } from "./baseApiCalls.js";
const o = "publisher_errors";
class c extends t {
  /**
   * Get publisher errors
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/publisher_errors/${businessId}`
   *
   * @param {string} businessId - The business ID
   * @param {PublisherErrorsRequest} content - PublisherErrorsRequest model according to backend
   * @returns {Promise<Record<string, any>>}
   */
  getPublisherErrorsV2 = async (r, s) => {
    const { data: e } = await this.post(
      `${o}/${r}`,
      s
    );
    return e;
  };
}
export {
  c as PublisherErrors
};
